import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
// Heights come from the shell contract (--control-height in web-shared/
// theme.css), so a surface marked `data-density="compact"` — Administration,
// the Desk — shrinks every control without touching a component.
// Focus is the platform-wide `--focus-ring` applied by :focus-visible in
// theme.css; no per-component ring, so every focusable thing looks the same.
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[color,background-color,border-color,box-shadow,transform] duration-150 outline-none disabled:pointer-events-none disabled:opacity-50 active:translate-y-px [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground shadow-sm hover:bg-accent-hover hover:shadow-md',
            secondary: 'bg-muted text-foreground shadow-xs hover:bg-muted/70 hover:shadow-sm',
            outline: 'border border-border bg-card text-foreground shadow-xs hover:bg-muted hover:shadow-sm',
            ghost: 'hover:bg-muted text-foreground',
            destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 hover:shadow-md',
            link: 'text-accent-text underline-offset-4 hover:underline',
        },
        size: {
            default: 'h-(--control-height) px-4',
            sm: 'h-(--control-height-sm) rounded-md px-3 text-xs',
            lg: 'h-10 rounded-md px-6',
            icon: 'h-(--control-height) w-(--control-height)',
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
});
export const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => (_jsx("button", { ref: ref, className: cn(buttonVariants({ variant, size }), className), ...props })));
Button.displayName = 'Button';
export { buttonVariants };
